import React, {Component} from 'react'
import PropTypes from 'prop-types'
import timeHumanize from "../../helpers/timeHumanize"
import classNames from 'classnames'


class ItemHeaderDetails extends Component {
    render() {
        const {item} = this.props
        const {product, barcodeNumber, orderNumber, shipped_at, created, totalItems} = item
        const {pos: itemIndex, type: productType, size, color, printed_at, status} = product

        return (
            <div className={classNames("ItemHeaderDetails", status)}>
                <h1 className="d-flex">
                    <strong>#{barcodeNumber}_{itemIndex}</strong>
                    <div className="Index">{itemIndex}/{totalItems}</div>
                </h1>

                <div className="OrderNumber">
                    <strong>Order number:</strong> {orderNumber}
                </div>

                <div className="Product d-flex mt-2 mb-2">
                    <div className="Color">
                        <strong>Type:</strong> {productType}
                    </div>
                    <div className="Size ml-2">
                        <strong>Size:</strong> {size}
                    </div>
                    <div className="Color ml-2">
                        <strong>Color:</strong> {color}
                    </div>
                </div>

                <div className="Details">
                    <div className="Created">
                        <strong>Created:</strong> {timeHumanize(created)}
                    </div>

                    {!!printed_at &&
                    <div className="Printed mt-1">
                        <strong>Printed:</strong> {timeHumanize(printed_at)}
                    </div>
                    }

                    {!!shipped_at &&
                    <div className="Shipped mt-1">
                        <strong>Shipped:</strong> {timeHumanize(shipped_at)}
                    </div>
                    }
                </div>

                <hr/>
            </div>
        )
    }
}

ItemHeaderDetails.propTypes = {
    item: PropTypes.object.isRequired,
}

export default ItemHeaderDetails
